class InfoTab {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-scope="infoTab"]',
			text: '[data-scope="text"]',
			form: '[data-scope="form"]',
            toggle: '[data-scope="toggle"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
        let product = this.$scope.data('product');
        this.$scope.find('[name*="product"]').val(product);
        this.initEventListeners();
	}

    initEventListeners() {
        this.$scope.on('click', this.config.toggle, this.toggleView.bind(this));
    }

    toggleView() {
        this.$scope.find(this.config.text).toggleClass('d-none');
        this.$scope.find(this.config.form).toggleClass('d-none');
    }
}

export default new InfoTab;
